import type { Platform } from '@client/src/types/order';

/**
 * 运行时配置声明
 * 由 client/public/env.js 在打包产物中挂载到 window._env_
 * 部署后可直接编辑 /env.js 修改，无需重新构建
 */
export interface RuntimeConfig {
  ORDER_PLACERS?: Partial<Record<Platform, string[]>>;
  PLATFORM_COUNTRIES?: Partial<Record<Platform, string[]>>;
}

declare global {
  interface Window {
    _env_?: RuntimeConfig;
  }
}

// 默认 fallback（当 window._env_ 未加载或某平台字段缺失时使用）
const DEFAULT_ORDER_PLACERS: Record<Platform, string[]> = {
  depop: ['Vivien', '子程', '惠子', '英国留子', '喵桑'],
  vinted: ['Vivien', '子程', '惠子', '英国留子', '喵桑', 'Eva'],
  poshmark: ['Vivien', '子程', '惠子', '英国留子', '喵桑'],
  ebay: ['Vivien', '子程', '惠子', '英国留子', '喵桑'],
};

const DEFAULT_PLATFORM_COUNTRIES: Record<Platform, string[]> = {
  depop: ['美国', '澳大利亚', '加拿大', '英国'],
  vinted: ['西欧', '中欧', '北欧', '英国'],
  poshmark: ['美国', '加拿大'],
  ebay: ['英国', '美国', '加拿大', '澳大利亚'],
};

const getEnv = (): RuntimeConfig =>
  typeof window !== 'undefined' && window._env_ ? window._env_ : {};

/** 获取指定平台的下单人列表（优先读 window._env_，缺失则用默认值） */
export function getOrderPlacers(platform: Platform): string[] {
  return (
    getEnv().ORDER_PLACERS?.[platform] ??
    DEFAULT_ORDER_PLACERS[platform] ??
    []
  );
}

/** 获取指定平台的国家列表（优先读 window._env_，缺失则用默认值） */
export function getPlatformCountries(platform: Platform): string[] {
  return (
    getEnv().PLATFORM_COUNTRIES?.[platform] ??
    DEFAULT_PLATFORM_COUNTRIES[platform] ??
    []
  );
}

/** 获取所有平台（用于 mock 遍历） */
export function getAllPlatforms(): Platform[] {
  const cfg = getEnv().PLATFORM_COUNTRIES ?? DEFAULT_PLATFORM_COUNTRIES;
  return Object.keys(cfg) as Platform[];
}
